const WWW = 'https://www.ofutonkobo.com';
const SHOP = 'https://shop.ofutonkobo.com';
const BAG_PATHS = new Set([
  // Explicit existing bag routes for the 14 newly localized markets.
  '/ad/bag/',
  '/ad/en/bag/',
  '/bg/bag/',
  '/bg/en/bag/',
  '/cy/bag/',
  '/cy/en/bag/',
  '/cz/bag/',
  '/gr/bag/',
  '/gr/en/bag/',
  '/hr/bag/',
  '/hr/en/bag/',
  '/hu/bag/',
  '/hu/en/bag/',
  '/lt/bag/',
  '/lt/en/bag/',
  '/lv/bag/',
  '/lv/en/bag/',
  '/pl/bag/',
  '/ro/bag/',
  '/ro/en/bag/',
  '/si/bag/',
  '/si/en/bag/',
  '/sk/bag/',
  '/sk/en/bag/',
  '/sm/bag/',
  '/nl/nl-nl/bag/', '/be/nl-be/bag/', '/be/fr-be/bag/',
  '/bag/', '/at/bag/', '/au/bag/', '/be/bag/', '/bh/en/bag/', '/ca/bag/',
  '/ch/bag/', '/ee/bag/', '/fi/bag/', '/fr/bag/', '/fr/en/bag/', '/hk/bag/',
  '/hk/en/bag/', '/ie/bag/', '/in/bag/', '/it/bag/', '/it/en/bag/', '/kr/en/bag/',
  '/kw/en/bag/', '/lu/bag/', '/mo/bag/', '/mt/bag/', '/mx/bag/', '/my/bag/',
  '/nl/bag/', '/nl/en/bag/', '/no/bag/', '/no/en/bag/', '/nz/bag/', '/om/en/bag/',
  '/pt/bag/', '/qa/en/bag/', '/sa/en/bag/', '/se/bag/', '/se/en/bag/', '/sg/bag/',
  '/sg/zh/bag/', '/th/en/bag/', '/tw/bag/', '/uk/bag/', '/vn/en/bag/',
]);

export function websiteBagFromCheckout(referrer) {
  let source;
  try { source = new URL(referrer); } catch { return null; }
  if (source.origin !== SHOP || source.username || source.password ||
      !/^\/checkouts\/(?:cn|c)\/[A-Za-z0-9_-]+\/[a-z]{2}(?:-[a-z]{2})?\/?$/.test(source.pathname)) return null;
  const paths = source.searchParams.getAll('ofk_bag_path');
  const placements = source.searchParams.getAll('ofk_placement');
  if (paths.length !== 1 || placements.length !== 1 || placements[0] !== 'bag_checkout' || !BAG_PATHS.has(paths[0])) return null;
  return WWW + paths[0];
}

export function cartReturnDecision({ nativeView = false, referrer }) {
  if (nativeView) return { kind: 'native' };
  const destination = websiteBagFromCheckout(referrer);
  return destination ? { kind: 'website', destination } : { kind: 'choice' };
}

if (typeof document !== 'undefined' && document.querySelector('[data-ofk-cart-choice]')) {
  const route = cartReturnDecision({ referrer: document.referrer });
  if (route.kind === 'website') {
    // Keep an explicit recovery link visible if navigation is interrupted.
    const link = document.querySelector('[data-ofk-website-bag]');
    if (link) {
      link.href = route.destination;
      link.hidden = false;
    }
    window.location.replace(route.destination);
  }
}
